<template>
    <card-list-item @click="$emit('click')" :class="{'active': active, 'complete': task.complete === 1}">
        <template v-slot:icon>
            <i class="fa-fw" :class="task.complete === 1 ? 'far fa-check-circle' : (active ? 'fas fa-circle' : 'far fa-circle')"></i>
        </template>
        <template v-slot:content>
            <div class="tile-title" :class="{'is-complete': task.complete === 1}">{{task.title}}</div>
            <div class="meta">
                <span>{{typeLabel(task.type)}}</span>
                <span v-if="task.status"> &middot; {{statusLabel(task.status)}}</span>
                <span v-if="task.payment"> &middot; {{paymentLabel(task.payment)}}</span>
            </div>
            <div class="meta" v-if="task.assigned_id && task.assigned_name">{{task.assigned_name}}</div>
            <div class="meta" :class="{'has-text-danger': overdue}" v-if="task.due_on && task.complete !== 1">Due {{task.due_on | moment('MM/DD/YYYY')}}</div>
            <div class="meta" v-if="context">{{context}}</div>
        </template>
        <template v-slot:status>
            <b-tag type="is-warning" v-if="task.complete !== 1"><i class="fas fa-tasks"></i></b-tag>
        </template>
        <template v-slot:details>
            <div class="details-rollout">
                <div class="data mt-3">
                    <data-row mini title="ID">{{task.id}}</data-row>
                    <data-row mini title="Created">{{task.created_at | moment('MM/DD/YYYY')}}</data-row>
                    <data-row mini title="Completed" v-if="task.completed_at">{{task.completed_at | moment('MM/DD/YYYY')}}</data-row>
                    <data-row mini title="Description" v-if="task.description">{{task.description}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import DataRow from "../TIER/components/DataRow";
    import CardListItem from "../TIER/components/CardListItem";
    import {typeLabel, statusLabel, paymentLabel} from "@/components/task_meta";

    export default {
        name: 'TaskListItem',
        components: {CardListItem, DataRow},
        props: {
            card: {
                required: true
            },
            task: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            },
            // Optional "where this task lives" line for queue lists (entity
            // title, traveller, trip).
            context: {
                type: String,
                default: ''
            }
        },
        computed: {
            // Open and past its due date (due today is not overdue).
            overdue: function () {
                return this.task.complete !== 1 && !!this.task.due_on
                    && String(this.task.due_on).slice(0, 10) < new Date().toISOString().slice(0, 10);
            }
        },
        methods: {
            typeLabel,
            statusLabel,
            paymentLabel
        }
    }
</script>

<style lang="scss" scoped>
    li {
        color: darken($t-primary, 10);

        .tile-title {
            font-size: .9rem;
            font-weight: 700;

            &.is-complete {
                text-decoration: line-through;
                opacity: 0.6;
            }
        }

        padding: 0.5rem 0;

        .details-rollout {
            margin-top: 0.5rem;
        }
    }
</style>
